import AdsExternalBanner from 'src/components/Banner/AdsExternalBanner';
import { useSelector } from 'src/hooks/useSelector';

const bannerPositions = [6, 12, 22, 32, 42];

const getPositionToBannersMap = (banners) => ({
    6: {
        bannerL: banners['serp-first-l'],
        bannerM: banners['serp-first-m'],
        bannerS: banners['serp-first-s'],
        bannerXS: banners['serp-first-xs'],
    },
    12: {
        bannerL: banners['serp-second-l'],
        bannerM: banners['serp-second-m'],
        bannerS: banners['serp-second-s'],
        bannerXS: banners['serp-second-xs'],
    },
    22: {
        bannerL: banners['serp-third-l'],
        bannerM: banners['serp-third-m'],
        bannerS: banners['serp-third-s'],
        bannerXS: banners['serp-third-xs'],
    },
    32: {
        bannerL: banners['serp-fourth-l'],
        bannerM: banners['serp-fourth-m'],
        bannerS: banners['serp-fourth-s'],
        bannerXS: banners['serp-fourth-xs'],
    },
    42: {
        bannerL: banners['serp-fifth-l'],
        bannerM: banners['serp-fifth-m'],
        bannerS: banners['serp-fifth-s'],
        bannerXS: banners['serp-fifth-xs'],
    },
});

const SearchResultBanners = ({ vacancyPosition }) => {
    const banners = useSelector((state) => state.banners);
    const adsSearchParams = useSelector((state) => state.adsSearchParams);
    if (!bannerPositions.includes(vacancyPosition)) {
        return null;
    }
    const bannersMap = getPositionToBannersMap(banners);
    const { bannerL, bannerM, bannerS, bannerXS } = bannersMap[vacancyPosition];
    const classNames = 'serp-special';
    const adsPositionInfo = `${bannerPositions.indexOf(vacancyPosition) + 1}_${vacancyPosition}`;
    return (
        <>
            {bannerL?.length > 0 && (
                <div className="banner-place-wrapper_show-on-l">
                    <div className={classNames}>
                        <AdsExternalBanner
                            {...bannerL[0]}
                            bannerAdTargeting={adsSearchParams}
                            positionInfo={adsPositionInfo}
                        />
                    </div>
                </div>
            )}
            {bannerM?.length > 0 && (
                <div className="banner-place-wrapper_show-on-m">
                    <div className={classNames}>
                        <AdsExternalBanner
                            {...bannerM[0]}
                            bannerAdTargeting={adsSearchParams}
                            positionInfo={adsPositionInfo}
                        />
                    </div>
                </div>
            )}
            {bannerS?.length > 0 && (
                <div className="banner-place-wrapper_show-on-s">
                    <div className={classNames}>
                        <AdsExternalBanner
                            {...bannerS[0]}
                            bannerAdTargeting={adsSearchParams}
                            positionInfo={adsPositionInfo}
                        />
                    </div>
                </div>
            )}
            {bannerXS?.length > 0 && (
                <div className="banner-place-wrapper_show-on-xs">
                    <div className="serp-special-test">
                        <AdsExternalBanner
                            {...bannerXS[0]}
                            bannerAdTargeting={adsSearchParams}
                            positionInfo={adsPositionInfo}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default SearchResultBanners;
